// frontend/src/components/Mobile/MobileLayout.jsx
// Top bar only — navigation between screens is the icon home page (/mobile).
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { FiLogOut, FiChevronLeft, FiGrid } from 'react-icons/fi';
import { MOBILE_MENU } from './mobileMenu';
import './Mobile.css';

const MobileLayout = ({ children, title, backTo }) => {
  const { logout } = useAuth();
  const navigate  = useNavigate();
  const location  = useLocation();

  const isHome = location.pathname === '/mobile';
  // A top-level screen (one of the home icons) always goes back to the home page;
  // deeper pages (e.g. a plano-teares detail) use their own backTo / history.
  const isTopLevel = MOBILE_MENU.some((m) => m.path === location.pathname);

  const handleBack = () => {
    if (isTopLevel) navigate('/mobile');
    else if (backTo) navigate(backTo);
    else navigate(-1);
  };

  return (
    <div className="mb-root">
      <header className="mb-topbar">
        <div className="mb-topbar-left">
          {!isHome ? (
            <button type="button" className="mb-icon-btn" onClick={handleBack}>
              <FiChevronLeft size={22} />
            </button>
          ) : (
            <FiGrid size={20} style={{ color: 'var(--primary)', marginLeft: 4 }} />
          )}
        </div>
        <span className="mb-topbar-title">{title || 'SmartPlantOps'}</span>
        <div className="mb-topbar-right">
          <button type="button" className="mb-icon-btn" onClick={logout} title="Sair">
            <FiLogOut size={18} />
          </button>
        </div>
      </header>

      <main className="mb-content mb-content--no-nav">
        {children}
      </main>
    </div>
  );
};

export default MobileLayout;